class LivedigitalSDKError extends Error {
  readonly errorCode: string;

  readonly meta?: Record<string, unknown>;

  constructor(msg?: string, errorCode?: string, meta?: Record<string, unknown>) {
    super(msg ?? 'Unexpected Livedigital SDK error');
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = new.target.name;
    this.errorCode = errorCode ?? 'unknown_error';
    this.meta = meta;
  }
}

export default LivedigitalSDKError;
